import {
  Checkbox,
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  ListItemText,
  Menu,
  MenuItem,
  Select,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import RemoveRoundedIcon from "@mui/icons-material/RemoveRounded";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import loginVector from "../../Assets/Login/loginVector.png";
import DashboardImg from "../../Assets/SvgImages/dashboard1.svg";
import dashboardImg1 from "../../Assets/SvgImages/dashboard2.svg";
import { MoreVert } from "@mui/icons-material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { CheckSubModulesPermissions } from "../../Functions/UserPermissionsFun";
import { SubModulesName } from "../../Redux";
import {
  useGetSalaryDueMonthsQuery,
  useGetSalaryGeneratedMonthsQuery,
} from "../AdminModules/PayRoll/PayrollQuery";
const MyCard = React.forwardRef((props, ref) => {
  const { sx, ...val } = props;
  return (
    <Grid
      ref={ref}
      sx={(t) => ({
        bgcolor: props?.bgcolor ? props?.bgcolor(t) : "background.paper",
        boxShadow: props?.removeshadow
          ? ""
          : // : "0 .75rem 1.5rem rgba(18,38,63,.03)",
            "rgba(0, 0, 0, 0.1) 0px 4px 12px",
        borderRadius: "13px",

        ...sx,
      })}
      {...val}
    >
      {props.children}
    </Grid>
  );
});

export default MyCard;

export const CustomCards = {
  DashboardCard: (props) => {
    const [hovered, setHovered] = useState(false);

    const myRef = useRef("");

    const handleMouseOver = () => setHovered(true);
    const handleMouseOut = () => setHovered(false);

    useEffect(() => {
      const node = myRef.current;
      if (node) {
        node.addEventListener("mouseover", handleMouseOver);
        node.addEventListener("mouseout", handleMouseOut);

        return () => {
          node.removeEventListener("mouseover", handleMouseOver);
          node.removeEventListener("mouseout", handleMouseOut);
        };
      }
    }, [myRef]);

    const [title, setTitle] = useState(props?.menuItems?.[0]?.title);
    const [value, setValue] = useState(props?.menuItems?.[0]?.value);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    useEffect(() => {
      if (
        !props?.isLoading ||
        !props?.isFetching ||
        props?.menuItems?.[0]?.value
      ) {
        setTitle(props?.menuItems?.[0]?.title);
        setValue(props?.menuItems?.[0]?.value);
      }
    }, [props?.isLoading, props?.isFetching, props?.menuItems?.[0]?.value]);

    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
      setAnchorEl(null);
    };

    return (
      <Grid
        item
        xs={props?.xs || 6}
        md={props?.md || 4}
        lg={props?.lg || 3}
        onClick={props?.Click}
        sx={{
          minWidth: "200px",
          minHeight: "110px",
          cursor: props?.Click ? "pointer" : "",
          transition: "all 0.2s",
          "&:hover": props?.Click
            ? {
                transform: "scale(1.03)",
              }
            : {},
          ...props.sx,
        }}
        {...(props.ParentSx || [])}
      >
        <MyCard
          ref={myRef}
          bgcolor={props.bgcolor}
          sx={{
            width: "100%",
            height: "100%",
            p: "20px",
            display: "flex",
            alignItems: {
              xs: "center",
              lg: props.largeCard ? "flex-start" : "center",
            },
            justifyContent: "space-between",
            position: "relative",
          }}
        >
          {props?.more && (
            <Typography
              sx={{
                width: "100%",
                textAlign: "right",
                color: "white",
                position: "absolute",
                right: "0px",
                top: "0px",
              }}
            >
              <IconButton
                id="basic-button"
                aria-controls={open ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
                color="inherit"
                sx={{ p: "1px" }}
              >
                <MoreVert sx={{ mt: "4px" }} />
              </IconButton>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
                anchorOrigin={{
                  vertical: "center",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
              >
                {props?.menuItems?.map((el, i) => (
                  <MenuItem
                    key={i}
                    onClick={() => {
                      setTitle(el?.title);
                      setValue(el?.value);
                      handleClose();
                    }}
                  >
                    {el?.title}
                  </MenuItem>
                ))}
              </Menu>
            </Typography>
          )}
          <Grid
            sx={{
              width: {
                xs: "calc(100% - 50px)",
                lg: `calc(100% - ${props.largeCard ? 0 : 50}px)`,
              },
              display: "flex",
              flexDirection: "column",
              justifyContent: {
                xs: "space-between",
                lg: props.largeCard ? "flex-start" : "space-between",
              },
              alignItems: "flex-start",
              height: "100%",
              overFlow: "hidden",
            }}
          >
            <Typography
              variant="body1"
              noWrap
              sx={{
                textTransform: "capitalize",
                color: "text.secondary",
                width: "100%",
              }}
            >
              <Grid
                component="span"
                onClick={() => {
                  props?.Click ? props.Click() : "";
                }}
                sx={{
                  cursor: props?.Click ? "pointer" : "default",
                  position: "relative",
                  zIndex: 100,
                  color: props.nameColor,
                  fontSize: "14px",
                }}
              >
                {props.name || ""}
                <Grid component="span" sx={{ fontSize: "12px" }}>
                  {title ? `(${title})` : ""}
                </Grid>
              </Grid>
            </Typography>
            <Typography
              variant="h5"
              sx={{
                textTransform: "capitalize",
                width: "100%",
                display: "flex",
                alignItems: "center",
                fontFamily: "Roboto, sans-serif",
                fontWeight: 400,
              }}
            >
              {props?.isLoading || props?.isFetching ? (
                <CircularProgress
                  size={25}
                  color={props?.valueColor ? "primary" : "inherit"}
                />
              ) : (
                <Grid
                  component="span"
                  sx={{
                    color: props.valueColor,
                    fontSize: "20px",
                    fontWeight: "bold",
                  }}
                >
                  {value || 0}
                </Grid>
              )}
              {((!!props.inc && !!parseInt(props.inc)) ||
                (!!props.dec && !!parseInt(props.dec))) && (
                <Grid
                  component="span"
                  sx={{ fontSize: "12px", pl: "5px", display: "flex" }}
                >
                  {!!props.inc && !!parseInt(props.inc) && (
                    <Grid
                      component="span"
                      sx={(theme) => ({
                        color: "icon.green",
                        bgcolor: `${theme.palette.icon.green}44`,
                        borderRadius: "6px",
                        display: "flex",
                        alignItems: "center",
                        mr: "6px",
                      })}
                    >
                      <AddRoundedIcon sx={{ fontSize: "15px" }} />
                      <Grid
                        component="span"
                        sx={{
                          p: "2px 6px",
                          pl: "0px",
                        }}
                      >
                        {props.inc}
                      </Grid>
                    </Grid>
                  )}
                  {!!props.dec && !!parseInt(props.dec) && (
                    <Grid
                      component="span"
                      sx={(theme) => ({
                        color: "#fc5603",
                        bgcolor: `${theme.palette.icon.warning}44`,
                        borderRadius: "6px",
                        display: "flex",
                        alignItems: "center",
                      })}
                    >
                      <RemoveRoundedIcon sx={{ fontSize: "15px" }} />
                      <Grid
                        component="span"
                        sx={{
                          p: "2px 6px",
                          pl: "0px",
                        }}
                      >
                        {props.dec}
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              )}
            </Typography>
            {props.childGrid ? props.childGrid : null}
          </Grid>
          <Grid
            sx={{
              width: { xs: "50px", lg: props.largeCard ? "0px" : "50px" },
              height: { xs: "50px", lg: props.largeCard ? "0px" : "50px" },
              borderRadius: "50%",
              bgcolor: props?.valueColor ? "primary.main" : "",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#ffffff",
              position: "relative",
              overflow: "hidden",
              "&::before": {
                bgcolor: "#ffffff15",
                content: `''`,
                height: "54px",
                left: "16px",
                position: "absolute",
                top: "-5px",
                transform: "rotate(32deg)",
                transition: "all .4s",
                width: " 8px",
              },
              "&::after": {
                bgcolor: "#ffffff25",
                content: `''`,
                height: "54px",
                border: `1px solid #fff`,
                position: "absolute",
                top: "-5px",
                transform: "rotate(32deg)",
                transition: "all .3s",
                width: " 8px",
                left: hovered ? "60px" : "-12px",
              },
            }}
          >
            {props.icon || ""}
          </Grid>
          <Grid
            sx={{
              width: { xs: 0, md: 0, lg: props.largeCard ? "35%" : 0 },
              position: "absolute",
              right: 0,
              bottom: 0,
              overflow: "hidden",
              opacity: "0.6",
            }}
          >
            <Grid
              component="img"
              sx={{ width: "100%" }}
              src={props.fee ? dashboardImg1 : DashboardImg}
            ></Grid>
          </Grid>
        </MyCard>
      </Grid>
    );
  },
  WelcomeCard: (props) => {
    return (
      <Grid
        item
        xs={6}
        md={4}
        lg={3}
        sx={{ minWidth: "200px", minHeight: "120px" }}
        {...(props.ParentSx || [])}
      >
        <MyCard
          sx={{
            width: "100%",
            height: "100%",
            overflow: "hidden",
          }}
        >
          <Grid
            sx={(theme) => ({
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "center",
              flexDirection: "column",
              p: "10px",
              width: "100%",
              // height: "100%",
              bgcolor: `${theme.palette.primary.light}4c`,
              position: "relative",
            })}
          >
            <Typography variant="body1" noWrap sx={{ color: "text.secondary" }}>
              Hey,{" "}
              <Grid
                component="span"
                onClick={() => {
                  props?.Click ? props.Click() : "";
                }}
                sx={{
                  color: "text.primary",
                  fontSize: "20px",
                  cursor: props?.Click ? "pointer" : "default",
                  position: "relative",
                  zIndex: 100,
                }}
              >
                {props?.user?.firstName}
              </Grid>
            </Typography>
            <Typography variant="body1" noWrap sx={{ color: "primary.main" }}>
              Welcome !
            </Typography>
            <Grid
              sx={{
                position: "absolute",
                right: 0,
                bottom: 0,
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
                maxHeight: "100%",
              }}
            >
              <Grid
                component="img"
                src={loginVector}
                sx={{ width: "40%", maxWidth: "150px", maxHeight: "100%" }}
              />
            </Grid>
          </Grid>
        </MyCard>
      </Grid>
    );
  },
  NewDashboardCard: (props) => {
    const [title, setTitle] = useState(props?.menuItems?.[0]?.title);
    const [value, setValue] = useState(props?.menuItems?.[0]?.value);

    useEffect(() => {
      if (!props?.isLoading || !props?.isFetching) {
        setTitle(props?.menuItems?.[0]?.title);
        setValue(props?.menuItems?.[0]?.value);
      }
    }, [props?.isLoading, props?.isFetching, props?.menuItems]);

    return (
      <Grid
        item
        xs={props?.xs || 6}
        md={props?.md || 4}
        lg={props?.lg || 3}
        onClick={props?.Click}
        sx={{
          minWidth: "200px",
          minHeight: "110px",
          borderRadius: "10px",
          cursor: props?.Click ? "pointer" : "",
          transition: "all 0.2s",
          "&:hover": props?.Click
            ? {
                transform: "scale(1.03)",
              }
            : {},
          ...props.sx,
        }}
        {...(props.ParentSx || [])}
      >
        <MyCard
          // ref={myRef}
          bgcolor={props.bgcolor}
          sx={{
            width: "100%",
            height: "100%",
            p: "20px",
            display: "flex",
            justifyContent: "flex-start",
            position: "relative",
            flexDirection: "column",
            alignItems: "space-between",
          }}
        >
          <Grid sx={{ display: "flex", justifyContent: "space-between" }}>
            <Grid>
              <Grid
                sx={{
                  fontWeight: "500",
                  fontSize: "14px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {props.name ? props.name : ""}{" "}
                <Typography sx={{ fontSize: "12px" }}>
                  {title ? `(${title})` : ""}
                </Typography>
              </Grid>

              <Grid sx={{ fontSize: "20px", fontWeight: "bold" }}>
                {value ? value : value === 0 ? 0 : null}
              </Grid>
            </Grid>
            <Grid component={"img"} sx={{ height: "55px" }} src={props?.icon} />
          </Grid>
          <Grid
            container
            sx={{
              display: "flex",
              fontSize: "13px",
              color: "text.dashboard",
              justifyContent: "space-between",
            }}
          >
            {props?.menuItems.map((item, i) => (
              <>
                {i !== 0 && (
                  <>
                    <Grid xs={9}>{item.title}</Grid>
                    <Grid xs={3} sx={{ textAlign: "right", fontWeight: "500" }}>
                      {item.value}
                    </Grid>
                  </>
                )}
              </>
            ))}
          </Grid>
        </MyCard>
      </Grid>
    );
  },

  NewDashboardCardFigma: (props) => {
    // Generate a random color pair (background + text)
    const getRandomColor = () => {
      const colors = [
        { bg: "#E8F5E9", text: "#2E7D32" }, // green
        { bg: "#FFEBEE", text: "#C62828" }, // red
        { bg: "#E3F2FD", text: "#1565C0" }, // blue
        { bg: "#FFF8E1", text: "#F9A825" }, // yellow
        { bg: "#F3E5F5", text: "#6A1B9A" }, // purple
        { bg: "#F1F8E9", text: "#558B2F" }, // dark green
        { bg: "#E0F2F1", text: "#00897B" }, // teal
      ];

      return colors[Math.floor(Math.random() * colors.length)];
    };

    return (
      <Grid
        item
        xs={props?.xs || 12}
        md={props?.md || 6}
        lg={props?.lg || 3}
        onClick={props?.Click}
        sx={{
          minWidth: "200px",
          minHeight: "110px",
          borderRadius: "10px",
          cursor: props?.Click ? "pointer" : "",
          transition: "all 0.2s",
          "&:hover": props?.Click ? { transform: "scale(1.03)" } : {},
          ...props.sx,
        }}
        {...(props.ParentSx || [])}
      >
        <MyCard
          bgcolor={props?.bgcolor || ((t) => "#FFF")}
          sx={{
            width: "100%",
            height: "100%",
            p: "20px",
            display: "flex",
            justifyContent: "flex-start",
            position: "relative",
            flexDirection: "column",
          }}
        >
          <Grid>
            {/* Header */}
            <Grid
              sx={{
                background: props?.headerBgColor || "#F5B800",
                padding: "15px 20px",
                fontSize: "14px",
                fontWeight: 600,
                color: props?.headerTextColor || "#000",
                margin: "-20px -20px 15px -20px",
                borderTopRightRadius: "16px",
                borderTopLeftRadius: "16px",
              }}
            >
              {props?.title}
            </Grid>

            {/* Value + Icon */}
            <Grid sx={{ display: "flex", justifyContent: "space-between" }}>
              <Grid
                sx={{
                  fontSize: "30px",
                  fontWeight: "700",
                  color: props?.valueColor || "#000",
                  marginBottom: "4px",
                }}
              >
                {props?.value}
              </Grid>
              <Grid>{props?.icon ?? ""}</Grid>
            </Grid>

            {/* Dynamic Subheading Chips */}
            {Array.isArray(props?.subHeading) &&
              props.subHeading.length > 0 && (
                <Grid
                  style={{
                    display: "flex",
                    gap: "8px",
                    flexWrap: "wrap",
                    marginTop: "8px",
                  }}
                >
                  {props.subHeading.map((item, idx) => {
                    const clr = getRandomColor();
                    return (
                      <Grid
                        key={idx}
                        sx={{
                          display: "flex",
                          gap: 1,
                          padding: "4px 8px",
                          background: clr.bg,
                          color: clr.text,
                          borderRadius: "4px",
                          fontSize: "12px",
                          fontWeight: 600,
                        }}
                      >
                        <Grid>{item?.value}</Grid>
                        <Grid>{item?.key}</Grid>
                      </Grid>
                    );
                  })}
                </Grid>
              )}
          </Grid>
        </MyCard>
      </Grid>
    );
  },
  SalaryDashboardCard: (props) => {
    const [title, setTitle] = useState(props?.menuItems?.[0]?.title);
    const [value, setValue] = useState(props?.menuItems?.[0]?.value);
    const [display, setDisplay] = useState(false);
    const [dueMonths, setDueMonths] = useState([]);
    const { data } = useGetSalaryGeneratedMonthsQuery({
      skip: !CheckSubModulesPermissions([SubModulesName.PayrollReports]),
    });
    const { data: dueData } = useGetSalaryDueMonthsQuery({
      skip: !CheckSubModulesPermissions([SubModulesName.PayrollReports]),
    });
    const priority = data?.data
      ?.slice()
      .sort((a, b) => b.priority - a.priority);
    const toggleDisplay = () => {
      setDisplay((prev) => !prev);
    };

    const [selectedValues, setSelectedValues] = useState([]);
    useEffect(() => {
      if (data?.data && priority?.[0]) {
        const defaultValues = data.data
          .filter((item) => item.priority === priority[0].priority)
          .map((ele) => ele.uid);
        setSelectedValues(defaultValues);
        props.handleMonthChange(defaultValues);
      }
    }, [data]);
    useEffect(() => {
      if (dueData?.data && priority?.[0]) {
        const defaultValues = dueData.data
          .filter((item) => item.priority === Number(priority[0].priority) + 1)
          .map((ele) => ele.uid);
        setDueMonths(defaultValues);
        props.handleDueMonthChange(defaultValues);
      }
    }, [dueData]);
    useEffect(() => {
      if (!props?.isLoading || !props?.isFetching) {
        setTitle(props?.menuItems?.[0]?.title);
        setValue(props?.menuItems?.[0]?.value);
      }
    }, [props?.isLoading, props?.isFetching, props?.menuItems]);
    const handleChange = (event) => {
      const selectedMonth = event.target.value;
      setSelectedValues(selectedMonth);
      if (selectedMonth.includes("all")) {
        const filteredSelected = selectedMonth.filter(
          (value) => value !== "all"
        );

        const allSelected = filteredSelected.length === data?.data?.length;

        const newSelectedValues = allSelected
          ? []
          : data?.data?.map((item) => item.uid);

        setSelectedValues(newSelectedValues);
        return props.handleMonthChange(newSelectedValues);
      } else {
        setSelectedValues(selectedMonth);
        return props.handleMonthChange(selectedMonth);
      }
    };

    const handleDueMonths = (event) => {
      const selectedMonth = event.target.value;
      setDueMonths(selectedMonth);
      if (selectedMonth.includes("all")) {
        const filteredSelected = selectedMonth.filter(
          (value) => value !== "all"
        );

        const allSelected = filteredSelected.length === dueData?.data?.length;

        const newSelectedValues = allSelected
          ? []
          : dueData?.data?.map((item) => item.uid);

        setDueMonths(newSelectedValues);
        return props.handleDueMonthChange(newSelectedValues);
      } else {
        setDueMonths(selectedMonth);
        return props.handleDueMonthChange(selectedMonth);
      }
      // const selectedIndex = data?.data?.findIndex(
      //   (item) => item.uid === selectedMonth
      // );
      // const nextMonth =
      //   selectedIndex !== -1 && selectedIndex + 1 < data?.data?.length
      //     ? data.data[selectedIndex + 1]
      //     : data?.data?.[selectedIndex];

      // props.handleMonthChange(selectedMonth, nextMonth);
    };
    const isAllSelected =
      selectedValues.length === data?.data?.length ||
      dueMonths.length === dueData?.data?.length;
    return (
      <Grid
        item
        xs={props?.xs || 6}
        md={props?.md || 4}
        lg={props?.lg || 3}
        // onClick={toggleDisplay}
        sx={{
          minWidth: "200px",
          minHeight: "110px",
          borderRadius: "10px",
          cursor: props?.Click ? "pointer" : "",
          transition: "all 0.2s",
          "&:hover": props?.Click
            ? {
                transform: "scale(1.03)",
              }
            : {},
          ...props.sx,
        }}
        {...(props.ParentSx || [])}
      >
        <MyCard
          bgcolor={props.bgcolor}
          sx={{
            width: "100%",
            height: "100%",
            p: "20px",
            display: "flex",
            justifyContent: "flex-start",
            position: "relative",
            flexDirection: "column",
            alignItems: "space-between",
          }}
        >
          <Grid sx={{ display: "flex", justifyContent: "space-between" }}>
            <Grid>
              <Grid
                sx={{
                  fontWeight: "500",
                  fontSize: "14px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {props.name ? props.name : ""}{" "}
                <Typography sx={{ fontSize: "12px" }}>
                  {title ? `(${title})` : ""}
                </Typography>
              </Grid>

              <Grid sx={{ fontSize: "20px", fontWeight: "bold" }}>
                {value && display ? value : value === 0 ? 0 : "*****"}
              </Grid>
            </Grid>
            {/* <Grid component={"img"} sx={{ height: "55px" }} src={props?.icon} /> */}
          </Grid>

          <Grid sx={{ position: "absolute", top: "10px", right: "10px" }}>
            <Tooltip title={!display ? `Click to View` : `Click to Hide`}>
              <IconButton onClick={toggleDisplay}>
                {display ? (
                  <Visibility sx={{ fontSize: "20px" }} />
                ) : (
                  <VisibilityOff sx={{ fontSize: "20px" }} />
                )}
              </IconButton>
            </Tooltip>
          </Grid>
          <Grid
            sx={{
              position: "absolute",
              top: "10px",
              right: "40px",
            }}
          >
            <FormControl variant="standard" sx={{ m: 0, maxWidth: 100 }}>
              {props.name === "Salary Details" && (
                <Select
                  multiple
                  value={selectedValues}
                  onChange={handleChange}
                  renderValue={(selected) =>
                    selected
                      .map(
                        (uid) =>
                          data?.data?.find((item) => item.uid === uid)?.month
                      )
                      .join(", ")
                  }
                  sx={{
                    fontSize: "10px",
                    padding: "2px",
                  }}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        maxHeight: "200px",
                        overflowY: "auto",
                      },
                    },
                  }}
                >
                  <MenuItem value="all">
                    <Checkbox checked={isAllSelected} />
                    <ListItemText primary="Select All" />
                  </MenuItem>
                  {data?.data?.map((item) => (
                    <MenuItem key={item.uid} value={item.uid}>
                      <Checkbox checked={selectedValues.includes(item.uid)} />{" "}
                      <ListItemText primary={item.month} />
                    </MenuItem>
                  ))}
                </Select>
              )}
              {props.name === "Due Details" && (
                <Select
                  multiple
                  value={dueMonths}
                  onChange={handleDueMonths}
                  defaultValue={
                    data?.data
                      ?.filter(
                        (item) => item.priority === priority?.[0]?.priority
                      )
                      ?.map((item) => item.uid) || []
                  }
                  renderValue={(selected) =>
                    selected
                      .map(
                        (uid) =>
                          dueData?.data?.find((item) => item.uid === uid)?.month
                      )
                      .join(", ")
                  }
                  sx={{
                    fontSize: "10px",
                    padding: "2px",
                  }}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        maxHeight: "200px",
                        overflowY: "auto",
                      },
                    },
                  }}
                >
                  <MenuItem value="all">
                    <Checkbox checked={isAllSelected} />
                    <ListItemText primary="Select All" />
                  </MenuItem>
                  {dueData?.data?.map((item) => (
                    <MenuItem key={item.uid} value={item.uid}>
                      <Checkbox checked={dueMonths.includes(item.uid)} />{" "}
                      <ListItemText primary={item.month} />
                    </MenuItem>
                  ))}
                </Select>
              )}
            </FormControl>
          </Grid>
          <Grid
            container
            sx={{
              display: "flex",
              fontSize: "13px",
              color: "text.dashboard",
              justifyContent: "space-between",
            }}
          >
            {props?.menuItems.map((item, i) => (
              <>
                {i !== 0 && (
                  <>
                    <Grid xs={9}>{item.title}</Grid>
                    {display ? (
                      <Grid
                        xs={3}
                        sx={{ textAlign: "right", fontWeight: "500" }}
                      >
                        {item.value}
                      </Grid>
                    ) : (
                      "*****"
                    )}
                  </>
                )}
              </>
            ))}
          </Grid>
        </MyCard>
      </Grid>
    );
  },
};
